<script lang="ts">
export default {
  name: "leftHome",
};
</script>
<script setup lang="ts">
import {store} from "@/store"
import { vue3ScrollSeamless } from "vue3-scroll-seamless";
import router from '@/router';
import * as echarts from 'echarts'
import { fontSize } from "@/common/common"
import { onMounted } from 'vue'
import BaseEcharts from '@/components/BaseEcharts/index.vue'
import { type EChartsCoreOption } from "@/hooks/useHookEchart"
import { getWaylineStatistic,getAlarmList } from "@/api/eventApi/index"
import { useFormatDate } from "@/hooks/userHookDate"
import homeAlert from "./home-alert.vue";

const useDate = useFormatDate()

const classOptions = {
  step: 1, // 数值越大速度滚动越快
  limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
  hoverStop: true, // 是否开启鼠标悬停stop
  direction: 1, // 0向下 1向上 2向左 3向右
  openWatch: false, // 开启数据实时监控刷新dom
  singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
  singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
  waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
};

const lineData:any = ref([])

const warningOptions = computed(() => ({
  grid: {
    left: "0%",
    right: "0%",
    top: "0%",
    bottom: "0%"
  },
  //你的代码
  color: [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#65aaff' },
      { offset: 1, color: 'rgba(101, 170, 255, 0.5)' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#1ae6b4' },
      { offset: 1, color: 'rgba(26, 230, 180, 0.5)' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#00e4ff' },
      { offset: 1, color: 'rgba(0, 228, 255, 0.5)' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#ffcc85' },
      { offset: 1, color: 'rgba(227, 183, 121, 0.5)' },
    ]),
  ],
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: fontSize(0.8),
      color: '#000',
    },
    formatter: (params: any) => {
      return params.name + ': ' + params.percent + '%'
    },
  },
  series: [
    {
      type: 'pie',
      roseType: 'radius',
      radius: ['35%', '90%'],
      center: ['50%', '50%'],
      data: lineData.value,
      itemStyle: {
        borderWidth: 2,
      },
      labelLine: {
        length: 0,
      },
      label: {
        formatter: (params: any) => {
          return '{name|' + params.name + ':\n }{value|' + params.percent + '%}'
        },
        rich: {
          name: {
            width:30,
            fontSize: fontSize(0.7),
            color: '#a6e4ff',
          },
          value: {
            width:1,
            fontSize: fontSize(0.7),
            color: '#fff',
          },
        },
      },
    },
    {
      type: 'pie',
      radius: ['25%', '35%'],
      center: ['50%', '50%'],
      data: lineData.value,
      itemStyle: {
        opacity: 0.3,
      },
      label: {
        show: false,
      },
    },
  ],
}))

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

const weekago = () =>{
  const today = new Date();
  const oneWeekAgoDate = new Date(today);
  oneWeekAgoDate.setDate(today.getDate() - 7);
  return oneWeekAgoDate.toISOString().split('T')[0];
}
const WaylineStatistic = () => {
  const params:any = {...page.value}
  params.startTime = weekago()
  params.endTime = ""
  params.provinceCode = import.meta.env.VITE_APP_AREACODE,
  params.cityCode = organizationData.value.cityCode,
  params.areaCode = organizationData.value.areaCode,
  params.orgId = organizationData.value.provinceCode,
  getWaylineStatistic(params).then((res)=>{
    if(res.list.length){
      res.list.forEach((result:any)=>{
        lineData.value.push({
          name:result.waylineName,
          value:result.eventNum,
          percent:result.percent
        })
      })
    }
  })
}


const page = ref({
  page: 1,
  size: 20,
});

const searchValue = ref({
  position: "",
  eventType: "",
  startTime: "",
  endTime: "",
  gatewaySn: "",
  jobId: "",
  cityCode:"",
  areaCode:"",
  provinceCode:"",
  orgId:"",
});

const eventList: any = ref([])

const format = computed(() => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  return `${year}-${month}-${day}`;
})

async function AlarmList() {
  searchValue.value.startTime = format.value
  searchValue.value.endTime = format.value
  searchValue.value.provinceCode = import.meta.env.VITE_APP_AREACODE
  searchValue.value.cityCode = organizationData.value.cityCode
  searchValue.value.areaCode = organizationData.value.areaCode
  searchValue.value.orgId = organizationData.value.provinceCode
  const params = { ...page.value, ...searchValue.value } as any;
  const result = await getAlarmList(params);
  eventList.value = result.list;
  // console.log(warningList.value)
}

const homeEventVisible = ref(false)
const emergencyBtn = () => {
  homeEventVisible.value = true
}

const routeEvent = () => {
  router.push({
    path: "/event"
  })
}

watch(() => store.informationListStore.informationStore().organizationData, (newVal, oldVal) => {
  WaylineStatistic()
  AlarmList()
}, {
  immediate: true,
  deep:true
})

onMounted(() => {
  
})
</script>

<template>
  <div class="left-home">
    <div class="big-title">港航事件</div>
    <div style="text-align: center;">
      <img style="cursor: pointer;width: 111px;height: 28px;" src="@/assets/images/yjcj-pic.png" alt=""
        @click="emergencyBtn">
    </div>
    <div class="warning-route">
      <div class="small-title">预警航线</div>
      <div class="warningChart">
        <base-echarts :options="warningOptions" v-if="lineData.length"/>
      </div>
    </div>
    <div class="day-event">
      <div class="small-title">今日事件</div>
      <vue3ScrollSeamless class="scroll-wrap" :classOptions="classOptions" :dataList="eventList">
        <div class="event-list" v-for="(item, index) in eventList" :key="index">
          <p>
            时间：{{ useDate.formatDate(item.eventTime) }}
            <span style="color: #FFCC00;">{{ useDate.formaTime(item.eventTime) }}</span>
          </p>
          <p>地点：{{ item.name }}</p>
          <p style="color: #00FFE5;">类型：{{ item.eventType }}</p>
        </div>
      </vue3ScrollSeamless>
    </div>
    <div class="more" @click="routeEvent">查看更多>>></div>
  </div>
  <home-alert v-model:homeEventVisible="homeEventVisible" />
</template>

<style scoped lang="scss">
.left-home {
  position: absolute;
  top: 7.5rem;
  left: 0;
  width: 21.1vw;
  height: 88vh;
  background: url("@/assets/images/left-monitor-bj.png") no-repeat center;
  background-size: 100% 100%;

  .warning-route {
    margin-top: 0.625rem;

    .warningChart {
      width: 90%;
      height: 20vh;
      margin: 1.25rem auto;
    }
  }

  .day-event {
    width: 100%;
    position: relative;

    .scroll-wrap {
      width: 95%;
      height: 39.5vh;
      overflow: hidden;
      margin: 0 auto;
      margin-top: 1.25rem;
      padding-top: 0.625rem;

      .event-list {
        width: 90%;
        height: 11vh;
        margin: 0.625rem auto;
        border-radius: 15px;
        background-color: rgba(0, 0, 0, 0.32);
        border: 2px solid #a8b0b8;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          position: relative;
          // flex: auto;
          font-size: 1rem;
          color: #fff;
          margin: .1875rem 1.875rem;
          line-height: normal;
          white-space: nowrap;
          /* 确保文本在一行内显示 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;

          /* 使用省略号表示文本溢出 */
          span {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
